import { jsx as _jsx } from "react/jsx-runtime";
import { Routes as RouterRoutes, Route } from "react-router-dom";
import { useMemo } from "react";
import { Routes } from "./routes";
export var RouterManager = function () {
    var routes = useMemo(function () {
        return Object.keys(Routes).map(function (path) {
            var RouteComponent = Routes[path];
            return _jsx(Route, { path: path, Component: RouteComponent }, path);
        });
    }, []);
    return _jsx(RouterRoutes, { children: routes });
};
